import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useCadastroCoresListaViewModel } from "../../viewModels/cadastro_cores_lista_view_model";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateCadastroCoresColumns } from "./columns";
import { useMemo } from "react";
import { CadastroCores } from "../../../domain/models/cadastro_cores";
import { CadastroCoresModal } from "./components/cadastro_cores_modal";

import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * CadastroCoresLista
 */

export const CadastroCoresLista = () => {
  const viewModel = useCadastroCoresListaViewModel();

  const columns = useMemo(() => {
    return GenerateCadastroCoresColumns({
      onActionEditar: viewModel.handleCadastroCoresModalOpenState,
      onActionDeletar: viewModel.handleCadastroCoresDeleteModalOpenState,
    });
  }, [
    viewModel.handleCadastroCoresModalOpenState,
    viewModel.handleCadastroCoresDeleteModalOpenState,
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[115px]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onMouseDown={e => {
                    viewModel.handleCadastroCoresModalOpenState(null, true);
                    e.preventDefault();
                  }}>
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Equipamentos de Medição
          </Link>
          <Typography className="text-primary-green">
            Cadastro de Cores
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Cadastro de Cores</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2">
            </div>
          </div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                <Header
                  dataDe={viewModel.filters.dataDe}
                  dataAte={viewModel.filters.dataAte}
                  cor={viewModel.filters.cor}
                  onDataChange={viewModel.handleDataChange}
                  onCorChange={viewModel.handleCorChange}
                  onClearFilters={viewModel.handleClearFilters}
                />

                <Stack spacing={0}>
                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                  <StyledDataGrid
                    tableName="cadastro_cores_lista"
                    disableColumnMenu={false}
                    getRowId={(row: CadastroCores) => row.idCadastroCor}
                    columns={columns}
                    loading={viewModel.loading}
                    disableRowSelectionOnClick={true}
                    rows={viewModel.cadastroCoresLista}
                    rowCount={viewModel.cadastroCoresLista.length}
                    getRowHeight={() => 'auto'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />
                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <CadastroCoresModal
        open={viewModel.cadastroCoresModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedCadastroCores={viewModel.selectedCadastroCores}
        onClose={() => viewModel.handleCadastroCoresModalOpenState(null, false)}
        onSubmit={viewModel.handleCadastroCoresSubmit}
      />

      <DeleteDialog
        open={viewModel.cadastroCoresDeleteModal}
        saving={viewModel.saving}
        title={`Você realmente deseja excluir este item?`}
        onClose={() => viewModel.handleCadastroCoresDeleteModalOpenState(null, false)}
        onDelete={() => viewModel.handleCadastroCoresDeleteSubmit()}
      />

    </>
  );
}